import style from "./style.scss";
import Link from "../link";
import NoWrap from "../no-wrap";
import namedRoutes from "../../settings/routes";

const Footer = () => (
  <footer class={style.footer}>
    <div class={style.wrapper}>
      <div class={style.links}>
        <Link class={style.brand} href="https://kingcountysar.org/">
          <img
            src="https://kingcountysar.org/wp-content/uploads/2021/01/logo.png"
            alt="King County Search and Rescue Association"
          />
        </Link>
        <ul class={style.social}>
          <li>
            <Link
              href="https://www.facebook.com/KingCountySAR"
              target="_blank"
              rel="noopener noreferrer"
            >
              Facebook
            </Link>
          </li>
          <li>
            <Link
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.instagram.com/kingcountysar/"
            >
              Instagram
            </Link>
          </li>
          <li>
            <Link
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.youtube.com/channel/UC4ZwNEZc93s8_mo5H5bNUJg"
            >
              YouTube
            </Link>
          </li>
          <li>
            <Link
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.linkedin.com/company/king-county-search-and-rescue-association/"
            >
              LinkedIn
            </Link>
          </li>

          <li>
            <Link href={namedRoutes.contact}>Contact</Link>
          </li>
        </ul>
      </div>
      <div class={style.legal}>
        <p class={style.disclaimer}>
          <span class={style.copyright}>© {new Date().getFullYear()}</span> King
          County Search and Rescue Association (KCSARA) is a{" "}
          <NoWrap>501(c)(3)</NoWrap> not-for-profit organization; Federal EIN{" "}
          <NoWrap>91-1331555</NoWrap>
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
